import React, { useState } from "react"
import { TextField } from "letalkui"
import { Grid } from "@material-ui/core"

import { ActionDialog } from "@/components"

import useValidation, { ErrorType } from "@/hooks/useValidation"

import RoleService, { CreateRoleInput } from "@/services/RoleService"
import { renderComponent } from "@/utils/node"

type CreateRoleDialogProps = {
	children?: React.ReactNode
	isDefaultOpen?: boolean
}

type CreateRoleDialogType = {
	open: (props: CreateRoleDialogProps) => void
}

const CreateRoleDialog: CreateRoleDialogType & React.FC<CreateRoleDialogProps> = (props) => {
	const {
		children,
		isDefaultOpen
	} = props

	const { validation, clearValidation, triggerValidation, clearAllValidations } = useValidation()

	const [createRoleData, setCreateRoleData] = useState<CreateRoleInput>({
		name: "",
		description: ""
	})
	const [isCreateRoleDialogOpened, setIsCreateRoleDialogOpened] = useState<boolean>(isDefaultOpen || false)

	const handleCloseCreateRoleDialog = () => {
		setIsCreateRoleDialogOpened(false)

		clearAllValidations()
	}

	const handleOpenCreateRoleDialog = () => {
		setIsCreateRoleDialogOpened(true)
	}

	const handleCreateRole = async () => {
		try {
			const createdRoleId = await RoleService.create(createRoleData)

			window.open(`/admin/attendance/roles/${createdRoleId}`, "_blank")

			handleCloseCreateRoleDialog()

			window.location.reload()
		} catch (error) {
			triggerValidation(error as ErrorType)
		}
	}

	const handleChangeCreateRoleData = (key: keyof CreateRoleInput, value: string) => {
		setCreateRoleData(prev => ({ ...prev, [key]: value }))

		clearValidation(key)
	}

	const renderDialog = () => {
		return (
			<ActionDialog
				title="Novo Cargo"
				saveText="SALVAR"
				openDialog={isCreateRoleDialogOpened}
				onSave={handleCreateRole}
				onClose={handleCloseCreateRoleDialog}
				fullWidth
			>
				<Grid container direction="column" spacing={2}>
					<Grid item>
						<TextField
							label="Nome"
							placeholder="Ex: Gestor de Automações"
							type="text"
							value={createRoleData.name}
							onChange={({ target }) => handleChangeCreateRoleData("name", target.value)}
							fullWidth
							errorText={validation?.name as string}
						/>
					</Grid>

					<Grid item>
						<TextField
							label="Descrição"
							placeholder="Ex: Função responsável por gerenciar as automações do sistema."
							type="text"
							value={createRoleData.description}
							onChange={({ target }) => handleChangeCreateRoleData("description", target.value)}
							fullWidth
							errorText={validation?.description as string}
							isOptional
						/>
					</Grid>
				</Grid>
			</ActionDialog>
		)
	}

	if (!children) {
		return renderDialog()
	}

	return (
		<Grid>
			<Grid onClick={handleOpenCreateRoleDialog}>
				{children}
			</Grid>
			{renderDialog()}
		</Grid>
	)
}

CreateRoleDialog.open = (props: CreateRoleDialogProps) => {
	renderComponent(
		"create-role-dialog",
		<CreateRoleDialog
			{...props}
			isDefaultOpen={true}
		/>
	)
}

export default CreateRoleDialog
